module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/ticket-ed8beb0b071e8d2aca21cdbaee2de389.svg";